// removed by extract-text-webpack-plugin
module.exports = {"modal-content":"_2A9z67SY9vs6Imr1hc6948","modal-actions":"_7X8J0VRcQEda91bJhvORS","modal-header":"iiIORuZZ_osR9T5IHFldQ","delete-button":"_1euEdfCuCmoN3I5C_IQz6V","close":"_1ZJ80UQWyefPIoIV9owc-Q","is-disabled":"_3k_5Vs557SkkQxjFXIp8su"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/ConfirmCancelModal/index.scss
// module id = 1171
// module chunks = 1